import request from "@/utils/request";
// 升级管理列表
export function clientVersionInfoList(params) {
  return request({
    url: "/system/clientversioninfo/clientVersionInfoList",
    method: "post",
    data: params,
  });
}
// 查询升级详情
export function clientVersionInfoById(id) {
  return request({
    url: `/system/clientversioninfo/clientVersionInfoById/${id}`,
    method: "GET",
  });
}
// 升级设备列表
export function upgradedSbList(params) {
  return request({
    url: "/system/sbsj/upgradedSbList",
    method: "post",
    data: params,
  });
}

// 发布名单设置
export function releaseScopeList(params) {
  return request({
    url: "/system/sbinfo/releaseScopeList",
    method: "post",
    data: params,
  });
}

// 全部取消升级
export function cancelAll(params) {
  const { versionid: id } = params;
  return request({
    url: `/system/clientupgraderange/cancelAll/${id}`,
    method: "get",
  });
}

// 升级列表设置
export function upgradeListSettings(params) {
  return request({
    url: `/system/clientupgraderange/upgradeListSettings`,
    method: "post",
    data: params,
  });
}
// 修改数据
export function updateclientVersionInfoById(params) {
  return request({
    url: `/system/clientversioninfo/updateclientVersionInfoById`,
    method: "post",
    data: params,
  });
}

// 修改发布状态
export function releaseStatus(params) {
  return request({
    url: `/system/clientversioninfo/releaseStatus`,
    method: "post",
    data: params,
  });
}

// 设备升级状态列表
export function upgradeStatusList(params) {
  return request({
    url: "/system/sbsj/upgradeStatusList",
    method: "post",
    data: params,
  });
}
